import React from 'react'
import { FormattedMessage } from 'react-intl'

const SuspenseFallback = () => (
  <div>
    <FormattedMessage id='Common.loading' />
  </div>
)

export default SuspenseFallback



// WEBPACK FOOTER //
// ./src/components/SuspenseFallback/index.js